import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6257dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option-box card" }
const _hoisted_2 = { class: "option-box__header" }
const _hoisted_3 = { class: "option-box__title" }
const _hoisted_4 = {
  key: 0,
  class: "option-box__optional ms-1"
}
const _hoisted_5 = {
  key: 0,
  class: "option-box__fieldset"
}
const _hoisted_6 = ["type", "name", "value", "checked", "onInput"]
const _hoisted_7 = { class: "option-box__item-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "option-box__item-additional"
}
const _hoisted_11 = {
  key: 3,
  class: "option-box__item-warning"
}
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = {
  key: 0,
  class: "option-box__item-price"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover ms-3" }, "i", -1))
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.isOptional)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " (" + _toDisplayString(_ctx.translate('shop.configuration.optional')) + ") ", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.options)
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createBlock(_TransitionGroup, {
              name: "list",
              tag: "div",
              class: "option-box__item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  key: option.id
                }, [
                  _createElementVNode("label", {
                    class: _normalizeClass(_ctx.labelAsHtml ? 'option-box__item-label option-box__item-label--as-html' : 'option-box__item-label')
                  }, [
                    _createElementVNode("input", {
                      type: _ctx.type,
                      name: _ctx.name,
                      value: option.id,
                      checked: _ctx.type === 'radio' ? _ctx.selectedOption === option.id : _ctx.selectedOption.includes(option.id),
                      onInput: (event) => _ctx.onChangeOption(event, option.id),
                      class: "option-box__item-input form-check-input"
                    }, null, 40, _hoisted_6),
                    _createElementVNode("span", _hoisted_7, [
                      (_ctx.labelAsHtml)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: option.label,
                            class: "option-box__item-text--as-html"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(option.label), 1)),
                      (option.labelSubText)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(option.labelSubText), 1))
                        : _createCommentVNode("", true),
                      (option.warning)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(option.warning), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          (_ctx.type === 'radio' ? _ctx.selectedOption !== option.id : !_ctx.selectedOption.includes(option.id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.priceDifference(option.id)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      (option.info)
                        ? (_openBlock(), _createBlock(_component_Popper, { key: 0 }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "popover__text",
                                innerHTML: option.info
                              }, null, 8, _hoisted_15)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}